<template>
    <v-expansion-panels v-model="panel" :disabled="disabled" multiple>
        <v-expansion-panel>
            <v-expansion-panel-header>
                <slot name="title"></slot>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <slot name="cont"></slot>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>

export default {
    name: 'Accordion',

    data(){
        return{
            panel: [0, 1],
            disabled: false,
            readonly: false,
        }
    },
    components: {
    },

}
</script>